import { Box, Typography } from "@mui/material";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import axios from "axios";
import parse from "html-react-parser";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import Footer from "./Footer";

function Support() {
  const [data, setData] = useState("");

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    axios
      .get(
        `${process.env.React_APP_BACKEND_URL}/api/getcontent?change=support`,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data.Content[0]);
        setData(response.data.Content[0]["support"]);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Box dir="rtl" sx={{ minHeight: "100vh", bgcolor: "#f6f9fc" }}>
      <Box sx={{ width: "min(980px, 92%)", mx: "auto", py: { xs: 3, md: 5 } }}>
        <Box sx={{ mb: 2.5, p: { xs: 2.25, md: 3 }, borderRadius: "22px", background: "linear-gradient(135deg, #eef6ff 0%, #ffffff 65%, #fff8ec 100%)", border: "1px solid #dceafb", display: "flex", alignItems: "center", gap: 1.75 }}>
          <Box sx={{ width: 52, height: 52, borderRadius: "16px", bgcolor: "#e3f0ff", color: "#1976d2", display: "grid", placeItems: "center", flexShrink: 0 }}>
            <SupportAgentRoundedIcon sx={{ fontSize: 30 }} />
          </Box>
          <Box>
            <Typography component="h1" sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, fontWeight: 800, fontSize: { xs: 24, md: 30 }, color: "#17324d", lineHeight: 1.2 }}>זקוקים לסיוע?</Typography>
            <Typography sx={{ fontFamily: `${process.env.REACT_APP_FONT}`, color: "#61758a", mt: 0.5, fontSize: { xs: 14, md: 15 } }}>אנחנו כאן כדי לעזור בכל שאלה הקשורה לשימוש בשירות</Typography>
          </Box>
        </Box>
        <Box sx={{ bgcolor: "#fff", border: "1px solid #e5edf5", borderRadius: "22px", boxShadow: "0 12px 34px rgba(22, 50, 77, 0.07)", p: { xs: 2.25, sm: 3, md: 4 }, fontFamily: `${process.env.REACT_APP_FONT}`, overflowWrap: "anywhere", "& *": { fontFamily: `${process.env.REACT_APP_FONT}` }, "& h1, & h2, & h3, & h4, & h5, & h6": { color: "#17324d", fontWeight: 800, lineHeight: 1.35, mt: 3, mb: 1.25 }, "& p, & li": { color: "#34495e", fontSize: { xs: 15, md: 16 }, lineHeight: 1.9 }, "& ul, & ol": { pr: 2.5 }, "& a": { color: "#1976d2", fontWeight: 700, textDecorationColor: "rgba(25,118,210,.35)" }, "& input, & textarea": { maxWidth: "100%" } }}>
          {data.length > 0 && <Box>{parse(data)}</Box>}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

export default Support;
